<div class="" [formGroup]="thirdStepFormControl">
  <h1 class="title">Adresse(s)</h1>
  <h5 class="title-text-muted text-muted fs-16">
    Ajoutez la ou les adresses de votre établissement.
    La première adresse ajoutée doit être votre siège social.</h5>

  <div formArrayName="adresses">
    @for (item of adressesControl.controls; track item; let i = $index; let first = $first) {
      <!--    <div *ngFor="let User of adressesControl.controls;  let i=index">-->
      <div [formGroupName]="i">
        <div class="border border--1 rounded my-2">
          <div class="border-bottom border-1 p-3 d-flex justify-content-between align-items-center">
            <mat-label class="card-title">
              {{ first ? 'Adresse du siège social' : 'site N˚' + (i + 1) }}

              @if (!first) {
                <span class="text-secondary" >
                {{ !addressValidation(i) ? '(Incomplet)' : '(Complet)' }}
              </span>
              }

            </mat-label>
            <div class="d-flex align-items-center" *ngIf="!first">
              <svg-icon class="cursor-pointer" (click)="deleteNewSite(i)"
                        src="/assets/icons/trash-red.svg"></svg-icon>
            </div>
          </div>
          <div class="px-4 py-2">
            <div class="my-3 w-100">
<!--               <app-custom-input [label]="'Nom du site'" [parentGroupName]="'{{$index}}'"  controlName="siteName"  [required]="true" ></app-custom-input> -->
<!--              <mat-label>Nom du site <span class="required">*</span></mat-label>-->
<!--              <input type="text" formControlName="name" class="w-100" />-->
              <app-custom-input [parentForm]="thirdStepFormControl"
                                [arrayName]="'adresses'"
                                [parentGroupName]="i"
                                [controlName]="'name'"
                                [label]="'Nom du site'"
                                [required]="true">
              </app-custom-input>
            </div>

            <div class="my-3 w-100">
              <!-- <app-custom-input [label]="'Adresse du site'" [parentGroupName]="'{{$index}}'" [parentForm]="thirdStepFormControl"  type="autocomplete" [options]="etablissementType" controlName="addressSite"  [required]="true" ></app-custom-input> -->
              <mat-label>Adresse du site <span class="required">*</span></mat-label>
              <input type="text"
                     class="w-100"
                     (input)="autoCompleteOnChange($event.target, i)"
                     [matAutocomplete]="auto">
              <mat-autocomplete #auto="matAutocomplete">
                @for (option of addressList; track option) {
                  <mat-option [value]="getAdresseFormated(option)" (onSelectionChange)="addressSelected(option, i)">{{ getAdresseFormated(option) }}</mat-option>
                }
              </mat-autocomplete>
              <div class="required"
                   *ngIf="adressesControl.controls[i]?.get('adress')?.touched
                   && (adressesControl.controls[i]?.get('adress')?.errors ||
                   adressesControl.controls[i]?.get('regionCode')?.errors)
                ">
                Veuillez saisir une addresse valide de la liste (En France)
              </div>
            </div>

            <div class="row my-3">
              <div class="col-6 d-flex flex-column">
                <mat-label>Pays <span class="required">*</span></mat-label>
                <input type="text" [formControlName]="'pays'"/>
              </div>
              <div class="col-6">
                <mat-label>Code postal <span class="required">*</span></mat-label>
                <input type="text" [formControlName]="'codePostale'" class="w-100"/>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-6 d-flex flex-column">
                <mat-label>Ville <span class="required">*</span></mat-label>
                <input type="text" [formControlName]="'ville'"/>
              </div>
              <div class="col-6">
                <mat-label>Département <span class="required">*</span></mat-label>
                <input type="text" [formControlName]="'departmentName'" class="w-100"/>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-6">
                <!-- <app-custom-input [label]="'CEDEX'" [parentGroupName]="'{{$index}}'"  controlName="cedex"  [required]="true" ></app-custom-input> -->
                <mat-label>CEDEX </mat-label>
                <input type="text" [formControlName]="'cededx'"/>
              </div>
            </div>
            <div class="row my-3">
              <app-text-separator text="Photos du site" textClass="w-px-150"></app-text-separator>
              <p class="text-black">Les photos peuvent offrir aux candidats une vision concrète de votre établissement,
                facilitant ainsi leur compréhension de l'environnement professionnel que vous proposez.</p>
              <p class="text-secondary fs-13">Vous pouvez les ajouter ulérieurement.</p>
              <app-custom-dragdrop-image
                (sendImage)="getImage($event, i)" [url]="item.get('addressImages')?.value" [isDeletble]="true" [limit]="2"
                                         ></app-custom-dragdrop-image>
            </div>

          </div>
        </div>
      </div>
      <!--    </div>-->


    }
  </div>

  <div class="d-flex justify-content-between align-items-center rounded border-1 border p-2 my-2"
  >
    <span class="card-title">Ajouter un site</span>
    <app-button color="primary" [srcIcon]="'assets/icons/plus-circle-primary.svg'"
                [stroked]="true" text="Ajouter" (handleClick)="addAddress()"
    ></app-button>
  </div>

  <div class="row my-2">
    <app-button color="primary" [disabled]="!thirdStepFormControl.valid" text="Suivant"
                (handleClick)="onSubmit.emit()"
                class="mx-auto text-center" [innerClass]="'p-3 w-100'"></app-button>
  </div>
</div>
